export default "__VITE_ASSET__ca94fa5f__"